document.addEventListener('DOMContentLoaded', function() {

  function getCountry() {
    return window.Shopify && window.Shopify.country ? window.Shopify.country : null;
  }

  function updateShippingCircle(cartTotal) {
    const circumference = 175.93;
    const country = getCountry();
    const wrapper = document.querySelector('.sbar-wrapper');
    if (!wrapper) return;

    if (country && country !== 'IT') {
      wrapper.innerHTML = `
        <div class="sbar-intl">
          <span class="sbar-intl-msg">🚚 Refrigerated shipping across Europe</span>
        </div>`;
      return;
    }

    let progress, missing, label1, label2;

    if (cartTotal < 50) {
      missing = (50 - cartTotal).toFixed(2).replace('.', ',');
      progress = (cartTotal / 50) * 100;
      label1 = 'per risparmiare';
      label2 = '€4,00 in spedizione';
    } else if (cartTotal < 120) {
      missing = (120 - cartTotal).toFixed(2).replace('.', ',');
      progress = ((cartTotal - 50) / 70) * 100;
      label1 = 'per la spedizione';
      label2 = 'quasi gratis 🚚';
    } else {
      progress = 100;
    }

    if (progress >= 100) {
      wrapper.innerHTML = `
        <div class="sbar-done">
          <svg viewBox="0 0 64 64" class="sbar-circle-svg">
            <circle cx="32" cy="32" r="28" class="sbar-track"/>
            <circle cx="32" cy="32" r="28" class="sbar-fill sbar-fill--done" style="stroke-dasharray:${circumference};stroke-dashoffset:0"/>
            <path d="M20 32 l8 8 l16-16" class="sbar-check"/>
          </svg>
          <p class="sbar-msg sbar-msg--done">🎉 Spedizione minima €3,90 sbloccata!</p>
        </div>`;
    } else {
      const filled = (circumference * progress) / 100;
      const offset = (circumference - filled).toFixed(1);
      wrapper.innerHTML = `
        <div class="sbar-progress">
          <svg viewBox="0 0 64 64" class="sbar-circle-svg">
            <circle cx="32" cy="32" r="28" class="sbar-track"/>
            <circle cx="32" cy="32" r="28" class="sbar-fill" style="stroke-dasharray:${circumference};stroke-dashoffset:${offset}"/>
          </svg>
          <div class="sbar-text">
            <span class="sbar-missing">+ €${missing}</span>
            <span class="sbar-label">${label1}<br><strong>${label2}</strong></span>
          </div>
        </div>`;
    }
  }

  document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail.cart) {
      updateShippingCircle(e.detail.cart.total_price / 100);
    }
  });

  document.addEventListener('drawerOpen', function() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateShippingCircle(cart.total_price / 100));
  });

  const observer = new MutationObserver(function() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateShippingCircle(cart.total_price / 100));
  });

  const subtotal = document.querySelector('[data-subtotal]');
  if (subtotal) observer.observe(subtotal, { childList: true, subtree: true });

});